import './header.scss';
import GLightbox from 'glightbox';
import AOS from 'aos';
export default async () => {

	// js-toggle-menu
	const toggleMobileButtons = document.querySelectorAll('.js-toggle-menu');
	const body = document.querySelector('body');
	toggleMobileButtons.forEach((button) => {
		button.addEventListener('click', () => {
			button.classList.toggle('is-active');
			if (body) {
				body.classList.toggle('is-menu-open');
			} else {
				console.log('Body element not found.');
			}
		});
	});

	// Aos
	AOS.init( {
		once: true,
		duration: 800,
		offset: 100,
	} );
	let scrollRef = 0;
	window.addEventListener( 'scroll', function () {
		scrollRef <= 10 ? scrollRef++ : AOS.refresh();
	} );

	// GLightbox
	GLightbox( {
		loop: true,
	} );

	const accordionTitles = document.querySelectorAll(".accordion-title");

	accordionTitles.forEach(title => {
		title.addEventListener("click", function (event) {
			const accordionItem = this.closest(".accordion-item");

			setTimeout(() => {
				window.scrollTo({
					top: accordionItem.offsetTop - 20, // Adjust for spacing
					behavior: "smooth" // Smooth scrolling effect
				});
			}, 300); // Delay to allow accordion to open first
		});
	});
};
